module.exports = __webpack_public_path__ + "img/kaggle.efb3dcc5.svg";